import SearchHead from "components/searchHead";
import { useTranslation } from "react-i18next";
import Calendar from "./calendar";

export default function RoomStatusPage() {
  const { t } = useTranslation();
  return (
    <>
      <SearchHead title={t("sub_ttl_curr")} formId={""} onClick={() => {}} />
      <Calendar />
    </>
  );
}
